import React, { useState } from 'react';

const IconBedFilled = ({
  size = 16,
  stroke = 2,
  color = "currentColor",
  hoverColor = "#1890ff",
  marginRight = 8
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={stroke}
      fill={isHovered ? hoverColor : color}
      stroke="none"
      style={{
        transition: "fill 0.3s ease",
        marginRight: `${marginRight}px`,
        marginLeft: "-4px",
        transform: "translateY(3px)", // <- aquí se baja
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M3 6a1 1 0 0 1 .993 .883l.007 .117v6h6v-5a1 1 0 0 1 .883 -.993l.117 -.007h8a3 3 0 0 1 2.995 2.824l.005 .176v8a1 1 0 0 1 -1.993 .117l-.007 -.117v-3h-16v3a1 1 0 0 1 -1.993 .117l-.007 -.117v-11a1 1 0 0 1 1 -1z" />
      <path d="M7 8a2 2 0 1 1 -1.995 2.15l-.005 -.15l.005 -.15a2 2 0 0 1 1.995 -1.85z" />
    </svg>
  );
};

export default IconBedFilled;
